import script from "./BaseEditorSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseEditorSection.vue?vue&type=script&setup=true&lang=js"

import "./BaseEditorSection.vue?vue&type=style&index=0&id=7cac129a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cac129a"]])

export default __exports__